import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"

const CommissionBySellerType = ({ setAddSellerTypeFormOpen }) => {

  const tableData = [
    { sellerType: "Individual Sellers", desc: "Independent sellers with lower sales volumes", commissionRate: "Default" },
    { sellerType: "Professional Sellers", desc: "Established businesses with higher sales volumes", commissionRate: "Default +2%" },
    { sellerType: "Brands", desc: "Large-scale enterprises with significant sales volumes", commissionRate: "Default +4%" },
  ]

  const columns = [
    { name: "Seller Type", selector: (row) => row.sellerType, grow: 0.5 },
    { name: "Description", selector: (row) => row.desc },
    { name: "Commission Rate", selector: (row) => row.commissionRate },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex flex-column">
          <button style={{ all: "unset" }}>Edit</button>
          <button style={{ all: "unset" }}>Deactivate</button>
        </div>
      ),
    },
  ]

  return (
    <>
      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow">
        <div className="fw-semibold fs-5">Commission Structure by Seller Type</div>
        <DynamicButton theme="blue" onClick={() => setAddSellerTypeFormOpen(prev => !prev)}>
          Add Seller Type
        </DynamicButton>
      </div>

      <DynamicDatatable columns={columns} data={tableData} type="yellow" />
    </>
  )
}

export default CommissionBySellerType
